/**
 * Replace hyphen in a CSS property name and convert to camel case.
 * @param {string} property A string that contains a hyphen.
 * @returns Camelcased property name.
 */
function makeCSSProperty(property) {
  const [first, second] = property.split('-')
  if (typeof second === 'undefined') return property

  let convertSecond
  switch (typeof second) {
    case 'string':
      convertSecond = second.charAt(0).toUpperCase() + second.slice(1)
      break
    case 'number':
      convertSecond = `${second}px`
      break
    default:
      throw new Error(`Missing case in makeCSSProperty for ${second} with type ${typeof second}`)
  }

  return first.concat(convertSecond)
}

/**
 * Converts a style object with an "emotion" CSS format to a plain JavaScript object.
 * @param {Object} style - The style object to convert.
 * @param {string} style.styles - The "emotion" CSS format string to convert.
 * @returns {Object} - A plain JavaScript object with CSS property-value pairs.
 */
export function emotionCSSToStyle(style) {
  const styles = style.styles.split(';label:')[0]
  const arrayOfProperties = {}

  for (const pair of styles.split(';')) {
    const [property, value] = pair.split(':')
    if (!property || typeof value === 'undefined') continue
    arrayOfProperties[makeCSSProperty(property)] = value
  }

  return arrayOfProperties
}
